export default "__VITE_ASSET__BwFSJFzI__"